import { useTranslation } from 'react-i18next';
import { FloorplanPreset } from '@domain/floorplan-preset';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

const deleteFloorplan = async (floorplanId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/floorplan-presets/${floorplanId}`;

  return request({ url, method: RequestMethod.DELETE });
};

export const useDeleteFloorplanPreset = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const queryClient = useQueryClient();

  return useGenericMutation(
    ['delete-floorplan-preset'],
    async ({ floorplanId }: { floorplanId: string }) => deleteFloorplan(floorplanId),
    {
      onSuccess: (data, variables) => {
        const floorplanQueryKey = ['get-floorplan-presets'];

        const previousFloorplanPresets = queryClient.getQueryData<FloorplanPreset[]>(floorplanQueryKey);

        if (!previousFloorplanPresets) {
          return;
        }

        queryClient.setQueryData(
          floorplanQueryKey,
          previousFloorplanPresets.filter((floorplan) => floorplan.id !== variables.floorplanId)
        );
        queryClient.invalidateQueries({ queryKey: ['get-admissions-presets'] });

        toast.push({
          title: t('offers:deletedOfferSuccessNotificationTitle'),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
